import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  updateFieldPosition,
  updatePageDescription,
  removePage,
} from "../../stores/customForm/customFormActions";
import CustomFormField from "./CustomFormField";
import DescriptionField from "./DescriptionField";

const CustomFormPage = ({ page }) => {
  const dispatch = useDispatch();
  const sortableRef = useRef(null);

  useEffect(() => {
    if (sortableRef.current) {
      $(sortableRef.current).sortable({
        connectWith: [".custom_form_fields_list", ".member_type_properties_list"],
        stop: (e, ui) => {
          const newPosition = ui.item.index();
          const oldPosition = parseInt(ui.item.attr("data-position"));
          $(ui.item.parent()).sortable("cancel");
          if (newPosition !== oldPosition) {
            handleSortStop(e, ui, newPosition);
          }
        },
        receive: (e, ui) => {
          const position = ui.item.index();
          $(ui.sender).sortable("cancel");
          handleSortStop(e, ui, position);
        },
      });
    }

    return () => {
      if (sortableRef.current) {
        $(sortableRef.current).sortable("destroy");
      }
    };
  }, [page.number]);

  const handleSortStop = (e, ui, position) => {
    const fieldId = parseInt(ui.item.attr("data-member-type-property-id"));
    const pageNumber = page.number;
    dispatch(updateFieldPosition(pageNumber, fieldId, position));
  };

  const handleDescriptionChange = (locale, description) => {
    const pageNumber = page.number;
    dispatch(updatePageDescription(pageNumber, locale, description));
  };

  const handleRemovePageClick = (e) => {
    e.preventDefault();
    dispatch(removePage(page.number));
  };

  return (
    <div className="ibox">
      <div className="ibox-title">
        <h5>Page {page.number}</h5>
        <div className="ibox-tools">
          <a
            className="btn btn-xs btn-danger"
            onClick={handleRemovePageClick}
            href="##"
          >
            Remove page
          </a>
        </div>
      </div>
      <div className="ibox-content">
        <DescriptionField
          key={"page" + page.number}
          pageKey={"page" + page.number}
          handleDescriptionChange={handleDescriptionChange}
          page={page}
        />
      </div>
      <div className="ibox-content">
        <ul
          className="custom_form_fields_list"
          data-page-number={page.number}
          ref={sortableRef}
        >
          {page.fields.map((fieldId, index) => (
            <CustomFormField
              key={fieldId}
              position={index}
              field_id={fieldId}
              page_number={page.number}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomFormPage;
